import _ from 'lodash';
import moment from 'moment';

import { SATURDAY, SUNDAY } from '../../../constants/weekDays';
import {
    APPOINTMENT_DATE_SELECTED,
    APPOINTMENT_SCHEDULE_RANGE_SELECTED,
    STORE_APPOINTMENT_DATA_SUCCESS,
    APPOINTMENT_DATA_ERROR,
    CLEAN_APPOINTMENT_STORE,
    STORE_ADDRESS_FORM_VALUES_SUCCESS,
    GEOLOCATE_ADDRESS_SUCCESS,
    CLEAN_ADVISOR_STORE,
    GET_ADVISORS_HOURS_SUCCESS,
    GET_ADVISORS_SUCCESS,
    SET_SELECTED_DATE_AND_TIME,
    SET_BEFORE_BUDGET,
    STORE_PICKUP_ADDRESS,
    PERSIST_DATEPICKERUI_VALUES,
    LOAD_INITIALS_DATEPICKERUI_VALUES,
    ADD_REPLACEMENT_VEHICLE,
    REMOVE_REPLACEMENT_VEHICLE,
    GET_EMPTY_DATES_SUCCESS
} from './types';

import { SET_LIMIT_APPOINTMENT_DATE } from '../../../components/shoppingCart/actions'

import {
    SAVE_QUERY_PARAMS
} from '../types';


const INITIAL_DATE = moment();
//Set time to 00:00:00:00
INITIAL_DATE.startOf('day');
/**
 * NOTE: COMMENTED BECAUSE THERE IS NO MORE "2 LABORAL DAYS RESTRICTION"
 */
// INITIAL_DATE.add(2, 'days');

// Check saturday and sunday and force initially out if weekend
if (INITIAL_DATE.isoWeekday() === SATURDAY) {
    INITIAL_DATE.add(2, 'days');
} else if (INITIAL_DATE.isoWeekday() === SUNDAY) {
    INITIAL_DATE.add(1, 'days');
}

const INITIAL_STATE = {
    beforeBudget: null,
    appointmentData: null,
    tempAppointmentData: {
        date: INITIAL_DATE.toDate(),
        scheduleRange: null,
        zipCode: null
    },
    tempAppointmentDateHours: null,
    tempAppointmentDate: null,
    showDatePickerUIContent: true,
    canRedirect: false,
    error: null,
    latLng: {},
    advisors: false,
    hours: false,
    hasToFetch: false,
    refreshFromHours: false,
    selectedDate: false,
    selectedTime: false,
    pickupAddress: null,
    replacementVehicle: false
}

export default function (state = INITIAL_STATE, action) {
    const tempAppointmentData = { ...state.tempAppointmentData };
    const appointmentData = { ...state.appointmentData };
    let cleaned = {};
    switch (action.type) {
        case APPOINTMENT_DATE_SELECTED:
            tempAppointmentData.date = action.payload.newDate;
            return {
                ...state,
                tempAppointmentData,
                error: null
            };
        case APPOINTMENT_SCHEDULE_RANGE_SELECTED:
            tempAppointmentData.scheduleRange = action.payload.newRange;
            return {
                ...state,
                tempAppointmentData,
            };
        case APPOINTMENT_DATA_ERROR:
            tempAppointmentData.date = action.payload.date;
            return {
                ...state,
                error: action.payload.error,
                tempAppointmentData
            };
        case STORE_APPOINTMENT_DATA_SUCCESS:
            return {
                ...state,
                appointmentData: {
                    ...action.payload,
                    date: moment(action.payload.date).format()
                },
                canRedirect: true,
                tempAppointmentData: INITIAL_STATE.tempAppointmentData
            }
        case CLEAN_APPOINTMENT_STORE:
            _.each(action.payload.props, (p) => {
                cleaned[p] = INITIAL_STATE[p];
            })
            return {
                ...state,
                ...cleaned
            };
        case STORE_ADDRESS_FORM_VALUES_SUCCESS:
            return {
                ...state,
                addressData: action.payload.values
            }
        case SAVE_QUERY_PARAMS:
            appointmentData.zipCode = action.queryParams.zipCode ? action.queryParams.zipCode : appointmentData.zipCode;
            tempAppointmentData.zipCode = action.queryParams.zipCode ? action.queryParams.zipCode : tempAppointmentData.zipCode;
            return {
                ...state,
                // appointmentData: { zipCode: action.queryParams.zipCode },
                appointmentData,
                // tempAppointmentData: { zipCode: action.queryParams.zipCode }
                tempAppointmentData,
            }
        case GEOLOCATE_ADDRESS_SUCCESS:
            return {
                ...state,
                latLng: action.payload.latLng,
            }
        case CLEAN_ADVISOR_STORE:
            if (action.payload.props === '*') {
                cleaned = INITIAL_STATE;
            } else if (Array.isArray(action.payload.props)) {
                action.payload.props.forEach((p) => {
                    cleaned[p] = INITIAL_STATE[p];
                })
            }
            return {
                ...state,
                ...cleaned,
            }
        case GET_ADVISORS_HOURS_SUCCESS:
            return {
                ...state,
                hours: action.payload.hours,
                hasToFetch: false,
                refreshFromHours: true,
            }
        case GET_ADVISORS_SUCCESS:
            return {
                ...state,
                advisors: action.payload.advisors,
                hasToFetch: false,
                refreshFromHours: false,
            }
        case SET_SELECTED_DATE_AND_TIME:
            return {
                ...state,
                selectedDate: action.payload.selectedDate,
                selectedTime: action.payload.selectedTime,
            }
        case PERSIST_DATEPICKERUI_VALUES:
            return {
                ...state,
                showDatePickerUIContent: true,
            }

        case PERSIST_DATEPICKERUI_VALUES:
            return {
                ...state,
                showDatePickerUIContent: true,
            }
        case LOAD_INITIALS_DATEPICKERUI_VALUES:
            return {
                ...state,
                tempAppointmentDateHours: null,
                tempAppointmentDate: null,
            }

        case ADD_REPLACEMENT_VEHICLE:
            return {
                ...state,
                replacementVehicle: true,
            }

        case REMOVE_REPLACEMENT_VEHICLE:
            return {
                ...state,
                replacementVehicle: false,
            }
            
        case SET_BEFORE_BUDGET:
            return {
                ...state,
                beforeBudget: action.payload.beforeBudget,
            }
        case STORE_PICKUP_ADDRESS:
            return {
                ...state,
                pickupAddress: action.payload.pickupAddress,
            }
        case SET_LIMIT_APPOINTMENT_DATE:
            let tempdate = moment().add(2, 'day')
            return {
                ...state,
                tempAppointmentDateHours: action.payload.tempHoursRange,
                tempAppointmentDate: tempdate,
                showDatePickerUIContent: false
            }
        case GET_EMPTY_DATES_SUCCESS:
            return {
                ...state,
                emptyDates: action.payload.emptyDates
            }
        default:
            return {
                ...state,
            };
    }
}



// WEBPACK FOOTER //
// ./src/workflow/checkout/appointment/reducer.js